var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoostActivation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 12.4996L7.49998 9.99956M9.99998 12.4996C11.164 12.0568 12.2807 11.4985 13.3333 10.8329M9.99998 12.4996V16.6662C9.99998 16.6662 12.525 16.2079 13.3333 14.9996C14.2333 13.6496 13.3333 10.8329 13.3333 10.8329M7.49998 9.99956C7.94343 8.84908 8.50182 7.74627 9.16665 6.70789C10.1376 5.15538 11.4897 3.8771 13.0941 2.99463C14.6986 2.11217 16.5022 1.65486 18.3333 1.66622C18.3333 3.93289 17.6833 7.91622 13.3333 10.8329M7.49998 9.99956H3.33331C3.33331 9.99956 3.79165 7.47456 4.99998 6.66622C6.34998 5.76622 9.16665 6.66622 9.16665 6.66622M3.74998 13.7496C2.49998 14.7996 2.08331 17.9162 2.08331 17.9162C2.08331 17.9162 5.19998 17.4996 6.24998 16.2496C6.84165 15.5496 6.83331 14.4746 6.17498 13.8246C5.85107 13.5154 5.42439 13.3368 4.97683 13.3229C4.52928 13.3091 4.09238 13.461 3.74998 13.7496Z",
    stroke: "#0265DC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostActivation);
export default __webpack_public_path__ + "static/media/BoostActivation.c0383ddcb526412d7c94b9cda3ccfc31.svg";
export { ForwardRef as ReactComponent };